import React from 'react';
import { PREVIOS_PERIOD } from '../AnalyticsConstants';
import { NavRightIcon } from 'assests/GmsIcons';

type MenuItemProps = {
  title: string;
  isSelected: boolean;
  children?: React.ReactNode;
  onToggle: () => void;
  onCheckboxChange: () => void;
  isOpen?: boolean;
  subscribedItems: string[];
  compareToMenu?: string;
  hasSubmenu?: boolean;
  allSubMenuItemsChecked?: boolean;
  someSubMenuItemsChecked?: boolean;
}

const MenuItem = ({ title, isSelected, children, onToggle, onCheckboxChange, isOpen, subscribedItems, compareToMenu, hasSubmenu = false, allSubMenuItemsChecked, someSubMenuItemsChecked }: MenuItemProps) => {
  const handleToggle = () => onToggle();
  const isMenuEnabled = subscribedItems.includes(title);

  return (
    <div className={`tw-form-check tw-pe-3 tw-ps-1 tw-justify-between hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`}>
      
      <div className={`tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-2 tw-w-full`}>
        <button
          disabled={!isMenuEnabled}
          onClick={onCheckboxChange}
          className={`tw-flex tw-items-center ${hasSubmenu ? 'tw-pointer-events-none' : ''}`}
        >
          <input
            type={compareToMenu === PREVIOS_PERIOD ? 'radio' : 'checkbox'}
            className="tw-accent-[#091CAA]"
            checked={isSelected || (allSubMenuItemsChecked != null && allSubMenuItemsChecked === true)}
            ref={ref => {
              if (ref) {
                ref.indeterminate = (someSubMenuItemsChecked && !allSubMenuItemsChecked) || false;
              }
            }}
            onChange={() => { }}
            disabled={!isMenuEnabled}
          />
          <label className={`tw-ms-2 ${!isMenuEnabled ? 'tw-text-gray-400' : 'tw-text-[#091E42]'}`}>
            {title}
          </label>
        </button>
        {hasSubmenu && (
          <button
            onClick={handleToggle}
            disabled={!isMenuEnabled}
            className="tw-p-2"
          >
            <NavRightIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default MenuItem;
